import { applyClientOptions, applyHttpOptions, } from '@zattoo/zapi/lib/helpers/http-client';
export const zapiCreate = (parameters) => {
    applyClientOptions({ basePath: `${parameters.host}/zapi/` });
    applyHttpOptions({
        mode: 'cors',
    });
};
